import {
    YMap,
    YMapComponentsProvider,
    YMapDefaultSchemeLayer,
    YMapDefaultFeaturesLayer,
    YMapListener,
    YMapFeature,
    YMapCollection,
    YMapControls,
    YMapGeolocationControl,
    YMapZoomControl,
    YMapHint,
    YMapDefaultMarker,
    YMapContainer,
    YMapControlButton,
    YMapHintContext,
    YMapMarker,
    YMapClusterer,
} from "ymap3-components";

import './AddressMap.css';

import { DEFAULT_MAP_STYLE } from "../../assets/mapStyles/default copy";
import { Y_MAP_API_KEY } from "../../assets/utils/constants";



function AddressMap({ location, setYmap, features, subClassName, className, preloader, disabled }) {

    return (
        <div className={`address-map${subClassName ? `-${subClassName}` : ''} ${className ? className : ''}`}>
            {preloader ? <div className="address-map__preloader" /> : null}
            <div className="address-map__box">
                <YMapComponentsProvider apiKey={Y_MAP_API_KEY} lang="ru_RU">
                    <YMap
                        key="map"
                        ref={(ymap) => {
                            if (!setYmap) return
                            console.log(ymap)
                            setYmap(ymap)
                        }}
                        location={location}
                        mode="vector"
                        theme="light"
                        controls={disabled ? [] : ['default']} // Disable controls if 'disabled' is true
                    // behaviors={disabled
                    //     ? ["disable('scrollZoom')", "disable('drag')", "disable('dblClickZoom')", "disable('multiTouch')"]
                    //     : ['default', "disable('scrollZoom')", "disable('drag')", "disable('dblClickZoom')", "disable('multiTouch')"]
                    // } // Disable map interactions if 'disabled' is true
                    >
                        <YMapDefaultSchemeLayer customization={DEFAULT_MAP_STYLE} />
                        <YMapDefaultFeaturesLayer />
                        {/* <YMapHint hint={getHint}>
                            <MyHint />
                        </YMapHint> */}
                        {/* <YMapListener onUpdate={onUpdate} /> */}

                        {/* <YMapCollection>
                            {features && features.map((feature, i) => (
                                <YMapFeature key={feature.id} {...feature.feature} onClick={() => {
                                    console.log(feature)
                                    if (feature.onClick && !disabled) {
                                        feature.onClick(feature)
                                    }
                                }} />
                            ))}
                        </YMapCollection> */}
                        <YMapDefaultMarker coordinates={location.center} />
                        {!disabled && (
                            <YMapControls position="top right">
                                <YMapZoomControl />
                            </YMapControls>
                        )}
                        {!disabled && (
                            <YMapControls position="bottom left">
                                <YMapGeolocationControl />
                            </YMapControls>
                        )}

                    </YMap>
                </YMapComponentsProvider>
            </div>
        </div>

    );
}

export default AddressMap